<template>
	<footer class="footer-section" style="background-color: transparent;padding-bottom: 0;" data-aos="zoom-in-up" data-aos-duration="500" data-aos-easing="ease-in-sine">
		<div class="bg-success rounded-top" style="width: 100%;height: 10px;position: relative;">
			<div class="d-flex justify-content-end" style="width: 50%;position: absolute;right: 5vw;bottom: -70px;max-height: 200px;">
				<img :src="data['url']" alt="" style="height: 100%; max-width: 100%;">
			</div>
		</div>
		<div class="bg-light" style="width: 100%;padding-bottom: 80px;">
			<div class="row" style="padding: 0 1% 0 5%;width: 100%;">
				<div class="col-lg-4 mt-5">
					<div class="mb-4 footer-logo-wrap"><div class="footer-logo">{{ data['name'] }}</div></div>
					<p class="mb-4" style="text-align: justify; white-space: pre-line;">
						{{ data['content'] }}
					</p>

					<ul class="list-unstyled custom-social">
						<li><a :href="data['facebook']" target="_blank"><span class="fa fa-brands fa-facebook-f"></span></a></li>
						<li><a :href="data['zalo']" target="_blank"><span class="fa fa-brands fa-z"></span></a></li>
						<li><a :href="data['twitter']" target="_blank"><span class="fa fa-brands fa-twitter"></span></a></li>
						<li><a :href="data['instagram']" target="_blank"><span class="fa fa-brands fa-instagram"></span></a></li>
					</ul>
				</div>

				<div class="col-lg-8 d-flex align-items-end justify-content-end">
					<div class="text-end" style="white-space: pre-line;padding-bottom: 5%;">
						{{ data['right'] }}
					</div>
				</div>
			</div>
		</div>
	</footer>
</template>

<script>
    import { ref, onValue } from "firebase/database";
    import { database } from '../../components/firebase'

    export default{
        data(){
            return{
                data:[],
            }
        },
        mounted(){
            const FooterRef = ref(database, 'Footer/');
            onValue(FooterRef, (snapshot) => {
                this.data = snapshot.val();
                // console.log(this.data);
            });
        }
    }
</script>